import React, { useEffect, useState } from 'react';
import { formatYouTubeVideoUrlToEmbed } from '../../lib/utils';

import { Shimmer } from './styles';
import SixteenNineIframe from './sixteen-nine-iframe';

interface YouTubeVideoComponentProps {
  url: string;
  accessibilityText?: string;
  containerClass: string;
  iframeId: string;
  testId?: string;
  allowFullScreen?: boolean;
}

const YouTubeVideoComponent = ({
  url,
  accessibilityText,
  containerClass,
  iframeId,
  testId,
  allowFullScreen = true
}: YouTubeVideoComponentProps): React.ReactElement | null => {
  const [videoEmbedUrl, setVideoEmbedUrl] = useState<string>(url);
  const [videoLoadingError, setVideoLoadingError] = useState(undefined);
  const isEmbedFormat = videoEmbedUrl.indexOf('embed') !== -1;

  useEffect(() => {
    if (!isEmbedFormat) {
      formatYouTubeVideoUrlToEmbed(videoEmbedUrl)
        .then(setVideoEmbedUrl)
        .catch(setVideoLoadingError);
    }
  }, [videoEmbedUrl, isEmbedFormat]);

  if (videoLoadingError) {
    throw videoLoadingError;
  }

  return videoEmbedUrl && isEmbedFormat ? (
    <SixteenNineIframe
      src={videoEmbedUrl}
      title={accessibilityText}
      id={iframeId}
      containerClass={containerClass}
      testId={testId}
      allowFullScreen={allowFullScreen}
    />
  ) : (
    <Shimmer />
  );
};

export default YouTubeVideoComponent;
